// Generated by purs version 0.13.8
"use strict";
var Data_Eq = require("../Data.Eq/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Generic_Rep_Show = require("../Data.Generic.Rep.Show/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Lunarbox_Data_ProjectId = require("../Lunarbox.Data.ProjectId/index.js");
var Lunarbox_Data_Route = require("../Lunarbox.Data.Route/index.js");
var Lunarbox_Data_Tutorial = require("../Lunarbox.Data.Tutorial/index.js");
var Routing_Duplex = require("../Routing.Duplex/index.js");
var Routing_Duplex_Generic = require("../Routing.Duplex.Generic/index.js");
var Routing_Duplex_Generic_Syntax = require("../Routing.Duplex.Generic.Syntax/index.js");
var Login = (function () {
    function Login() {

    };
    Login.value = new Login();
    return Login;
})();
var Logout = (function () {
    function Logout() {

    };
    Logout.value = new Logout();
    return Logout;
})();
var Profile = (function () {
    function Profile() {

    };
    Profile.value = new Profile();
    return Profile;
})();
var Register = (function () {
    function Register() {

    };
    Register.value = new Register();
    return Register;
})();
var Projects = (function () {
    function Projects() {

    };
    Projects.value = new Projects();
    return Projects;
})();
var Project = (function () {
    function Project(value0) {
        this.value0 = value0;
    };
    Project.create = function (value0) {
        return new Project(value0);
    };
    return Project;
})();
var Clone = (function () {
    function Clone(value0) {
        this.value0 = value0;
    };
    Clone.create = function (value0) {
        return new Clone(value0);
    };
    return Clone;
})();
var Tutorial = (function () {
    function Tutorial(value0) {
        this.value0 = value0;
    };
    Tutorial.create = function (value0) {
        return new Tutorial(value0);
    };
    return Tutorial;
})();
var CompleteTutorial = (function () {
    function CompleteTutorial(value0) {
        this.value0 = value0;
    };
    CompleteTutorial.create = function (value0) {
        return new CompleteTutorial(value0);
    };
    return CompleteTutorial;
})();
var Tutorials = (function () {
    function Tutorials() {

    };
    Tutorials.value = new Tutorials();
    return Tutorials;
})();
var genericEndpoint = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof Login) {
        return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
    };
    if (x instanceof Logout) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
    };
    if (x instanceof Profile) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
    };
    if (x instanceof Register) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
    };
    if (x instanceof Projects) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
    };
    if (x instanceof Project) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
    };
    if (x instanceof Clone) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))));
    };
    if (x instanceof Tutorial) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))));
    };
    if (x instanceof CompleteTutorial) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))));
    };
    if (x instanceof Tutorials) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)))))))));
    };
    throw new Error("Failed pattern match at Lunarbox.Api.Endpoint (line 33, column 1 - line 33, column 54): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return Login.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return Logout.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return Profile.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
        return Register.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
        return Projects.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
        return new Project(x.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
        return new Clone(x.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
        return new Tutorial(x.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
        return new CompleteTutorial(x.value0.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))))))) {
        return Tutorials.value;
    };
    throw new Error("Failed pattern match at Lunarbox.Api.Endpoint (line 33, column 1 - line 33, column 54): " + [ x.constructor.name ]);
});
var showEndpoint = new Data_Show.Show(Data_Generic_Rep_Show.genericShow(genericEndpoint)(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Login";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Logout";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Profile";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Register";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Projects";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Lunarbox_Data_ProjectId.showProjectId))(new Data_Symbol.IsSymbol(function () {
    return "Project";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Lunarbox_Data_ProjectId.showProjectId))(new Data_Symbol.IsSymbol(function () {
    return "Clone";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Lunarbox_Data_Tutorial.showTutorialId))(new Data_Symbol.IsSymbol(function () {
    return "Tutorial";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Lunarbox_Data_Tutorial.showTutorialId))(new Data_Symbol.IsSymbol(function () {
    return "CompleteTutorial";
})))(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Tutorials";
})))))))))))));
var eqEndpoint = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Login && y instanceof Login) {
            return true;
        };
        if (x instanceof Logout && y instanceof Logout) {
            return true;
        };
        if (x instanceof Profile && y instanceof Profile) {
            return true;
        };
        if (x instanceof Register && y instanceof Register) {
            return true;
        };
        if (x instanceof Projects && y instanceof Projects) {
            return true;
        };
        if (x instanceof Project && y instanceof Project) {
            return Data_Eq.eq(Lunarbox_Data_ProjectId.eqProjectId)(x.value0)(y.value0);
        };
        if (x instanceof Clone && y instanceof Clone) {
            return Data_Eq.eq(Lunarbox_Data_ProjectId.eqProjectId)(x.value0)(y.value0);
        };
        if (x instanceof Tutorial && y instanceof Tutorial) {
            return Data_Eq.eq(Lunarbox_Data_Tutorial.eqTutorialId)(x.value0)(y.value0);
        };
        if (x instanceof CompleteTutorial && y instanceof CompleteTutorial) {
            return Data_Eq.eq(Lunarbox_Data_Tutorial.eqTutorialId)(x.value0)(y.value0);
        };
        if (x instanceof Tutorials && y instanceof Tutorials) {
            return true;
        };
        return false;
    };
});
var ordEndpoint = new Data_Ord.Ord(function () {
    return eqEndpoint;
}, function (x) {
    return function (y) {
        if (x instanceof Login && y instanceof Login) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Login) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Login) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Logout && y instanceof Logout) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Logout) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Logout) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Profile && y instanceof Profile) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Profile) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Profile) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Register && y instanceof Register) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Register) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Register) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Projects && y instanceof Projects) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Projects) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Projects) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Project && y instanceof Project) {
            return Data_Ord.compare(Lunarbox_Data_ProjectId.ordProjectID)(x.value0)(y.value0);
        };
        if (x instanceof Project) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Project) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Clone && y instanceof Clone) {
            return Data_Ord.compare(Lunarbox_Data_ProjectId.ordProjectID)(x.value0)(y.value0);
        };
        if (x instanceof Clone) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Clone) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Tutorial && y instanceof Tutorial) {
            return Data_Ord.compare(Lunarbox_Data_Tutorial.ordTutorialId)(x.value0)(y.value0);
        };
        if (x instanceof Tutorial) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Tutorial) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof CompleteTutorial && y instanceof CompleteTutorial) {
            return Data_Ord.compare(Lunarbox_Data_Tutorial.ordTutorialId)(x.value0)(y.value0);
        };
        if (x instanceof CompleteTutorial) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof CompleteTutorial) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Tutorials && y instanceof Tutorials) {
            return Data_Ordering.EQ.value;
        };
        throw new Error("Failed pattern match at Lunarbox.Api.Endpoint (line 31, column 1 - line 31, column 44): " + [ x.constructor.name, y.constructor.name ]);
    };
});
var endpointCodec = Routing_Duplex.root(Routing_Duplex.prefix("api")(Routing_Duplex_Generic.sum(genericEndpoint)(Routing_Duplex_Generic.gRouteSum(Routing_Duplex_Generic.gRouteConstructor(new Data_Symbol.IsSymbol(function () {
    return "Login";
}))()(Routing_Duplex_Generic.gRouteNoArguments))(Routing_Duplex_Generic.gRouteSum(Routing_Duplex_Generic.gRouteConstructor(new Data_Symbol.IsSymbol(function () {
    return "Logout";
}))()(Routing_Duplex_Generic.gRouteNoArguments))(Routing_Duplex_Generic.gRouteSum(Routing_Duplex_Generic.gRouteConstructor(new Data_Symbol.IsSymbol(function () {
    return "Profile";
}))()(Routing_Duplex_Generic.gRouteNoArguments))(Routing_Duplex_Generic.gRouteSum(Routing_Duplex_Generic.gRouteConstructor(new Data_Symbol.IsSymbol(function () {
    return "Register";
}))()(Routing_Duplex_Generic.gRouteNoArguments))(Routing_Duplex_Generic.gRouteSum(Routing_Duplex_Generic.gRouteConstructor(new Data_Symbol.IsSymbol(function () {
    return "Projects";
}))()(Routing_Duplex_Generic.gRouteNoArguments))(Routing_Duplex_Generic.gRouteSum(Routing_Duplex_Generic.gRouteConstructor(new Data_Symbol.IsSymbol(function () {
    return "Project";
}))()(Routing_Duplex_Generic.gRouteArgument))(Routing_Duplex_Generic.gRouteSum(Routing_Duplex_Generic.gRouteConstructor(new Data_Symbol.IsSymbol(function () {
    return "Clone";
}))()(Routing_Duplex_Generic.gRouteArgument))(Routing_Duplex_Generic.gRouteSum(Routing_Duplex_Generic.gRouteConstructor(new Data_Symbol.IsSymbol(function () {
    return "Tutorial";
}))()(Routing_Duplex_Generic.gRouteArgument))(Routing_Duplex_Generic.gRouteSum(Routing_Duplex_Generic.gRouteConstructor(new Data_Symbol.IsSymbol(function () {
    return "CompleteTutorial";
}))()(Routing_Duplex_Generic.gRouteArgument))(Routing_Duplex_Generic.gRouteConstructor(new Data_Symbol.IsSymbol(function () {
    return "Tutorials";
}))()(Routing_Duplex_Generic.gRouteNoArguments)))))))))))({
    Login: Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteNoArguments))("auth")(Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteNoArguments))("login")(Routing_Duplex_Generic.noArgs)),
    Register: Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteNoArguments))("users")(Routing_Duplex_Generic.noArgs),
    Logout: Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteNoArguments))("auth")(Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteNoArguments))("logout")(Routing_Duplex_Generic.noArgs)),
    Profile: Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteNoArguments))("users")(Routing_Duplex_Generic.noArgs),
    Projects: Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteNoArguments))("projects")(Routing_Duplex_Generic.noArgs),
    Project: Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteAll))("projects")(Lunarbox_Data_Route.projectId(Routing_Duplex.segment)),
    Clone: Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteArgument))("projects")(Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteAll))("clone")(Lunarbox_Data_Route.projectId(Routing_Duplex.segment))),
    Tutorial: Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteAll))("tutorials")(Lunarbox_Data_Route.tutorialId(Routing_Duplex.segment)),
    CompleteTutorial: Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteArgument))("tutorials")(Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteAll))("complete")(Lunarbox_Data_Route.tutorialId(Routing_Duplex.segment))),
    Tutorials: Routing_Duplex_Generic_Syntax.gsep(Routing_Duplex_Generic_Syntax.gsepStringRoute(Routing_Duplex_Generic.gRouteNoArguments))("tutorials")(Routing_Duplex_Generic.noArgs)
})));
module.exports = {
    Login: Login,
    Logout: Logout,
    Profile: Profile,
    Register: Register,
    Projects: Projects,
    Project: Project,
    Clone: Clone,
    Tutorial: Tutorial,
    CompleteTutorial: CompleteTutorial,
    Tutorials: Tutorials,
    endpointCodec: endpointCodec,
    eqEndpoint: eqEndpoint,
    ordEndpoint: ordEndpoint,
    genericEndpoint: genericEndpoint,
    showEndpoint: showEndpoint
};
